import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import styles from "../styling/homePage.module.css";

function Home() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/form");
  };

  const handlePantheonBtn = () => {
    window.location.href = "https://pantheon.nyc";
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.homeContainer}>
        <nav className={styles.homeNav}>
          <div className={styles.logo}>Hatch</div>
          <div className={styles.navButtons}>
            <button onClick={handlePantheonBtn} className={styles.recruiterBtn}>
              Pantheon
            </button>
            <button onClick={handleGetStarted} className={styles.signInBtn}>
              Join Platform →
            </button>
          </div>
        </nav>

        <main className={styles.heroSection}>
          <div className={styles.heroContent}>
            <div className={styles.badge}>
              Access talent, investors and mentorship.
            </div>
            <h1 className={styles.heroTitle}>The founder network for Pantheon.</h1>
            <p className={styles.heroDescription}>
              Pantheon Bookface is the exclusive community platform for Pantheon
              VC, connecting visionary founders, investors, and industry leaders
              to shape the future of technology and innovation.
            </p>

            <button onClick={handleGetStarted} className={styles.heroCta}>
              Get Started
            </button>

            <div className={styles.featureGrid}>
              <div className={styles.featureCard}>
                <h3 className={styles.title}>Join the Network</h3>
                <p className={styles.description}>
                  Create your profile and connect with the Pantheon ecosystem of
                  founders and investors.
                </p>
              </div>
              <div className={styles.featureCard}>
                <h3 className={styles.title}>Access Resources</h3>
                <p className={styles.description}>
                  Get exclusive access to events, mentorship, and investment
                  opportunities.
                </p>
              </div>
              <div className={styles.featureCard}>
                <h3 className={styles.title}>Grow Together</h3>
                <p className={styles.description}>
                  Collaborate with fellow founders and leverage the power of the
                  Pantheon network.
                </p>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
